module.exports = __webpack_public_path__ + "static/media/doctor-02.5999b1fb.svg";